module.exports = __webpack_public_path__ + "static/media/et-desktop.a3af7b80.png";